import { makeStyles } from '@material-ui/core/styles'

import { colors } from '../../theme'

export const useStyles = makeStyles(() => ({
  bannerText: {
    color: colors.textBlue,
    fontFamily: 'Mont-Bold',
    fontSize: '0.8rem',
  },
  mainView: {
    alignItems: 'center',
    backgroundColor: colors.brandOrange,
    display: 'flex',
    height: '36px',
    justifyContent: 'center',
    position: 'fixed',
    width: '100%',
    zIndex: 999,
    marginTop:'-36px'
  },
}))
